import { ThemeToggle } from '@ntconsult/aluma-react';
import { useUIStore } from '@store/uiStore';
import { useTranslation } from 'react-i18next';

export function ThemeMenu() {
  const { t } = useTranslation('common');
  const theme = useUIStore((s) => s.theme);
  const setTheme = useUIStore((s) => s.setTheme);
  return (
    <ThemeToggle
      mode="icon"
      value={theme}
      onValueChange={setTheme}
      aria-label={t('nav.theme')}
      labels={{
        light: t('themes.light'),
        dark: t('themes.dark'),
        system: t('themes.system'),
      }}
    />
  );
}
